import { createContext } from 'react'
import type {
  OrderDateRangePreset,
  OrderFulfillmentGroup,
  OrderShippingMethod,
  OrderStatusCounts,
  OrderStatusFilter,
  OrderSummary,
} from '../../../types'

export type OrderFulfillmentFilter = OrderFulfillmentGroup | 'all'

export interface OrderListContextValue {
  storeId: string

  orders: OrderSummary[]
  counts: OrderStatusCounts
  isLoading: boolean
  isFetching: boolean
  isError: boolean
  error: unknown

  statusFilter: OrderStatusFilter
  setStatusFilter: (value: OrderStatusFilter) => void

  fulfillmentFilter: OrderFulfillmentFilter
  setFulfillmentFilter: (value: OrderFulfillmentFilter) => void

  locationFilter: string
  setLocationFilter: (value: string) => void

  dateRangePreset: OrderDateRangePreset
  setDateRangePreset: (value: OrderDateRangePreset) => void

  keyword: string
  setKeyword: (value: string) => void

  shippingMethods: OrderShippingMethod[]

  onSelectOrder?: (orderId: string) => void

  currentPage: number
  totalPages: number
  totalItems: number
  limit: number
  canGoBack: boolean
  canGoNext: boolean
  showingStart: number
  showingEnd: number
  goToPrevPage: () => void
  goToNextPage: () => void
  goToPage: (page: number) => void
  setLimit: (limit: number) => void

  sortBy: string | undefined
  sort: 'asc' | 'desc' | undefined
  setSort: (sortBy: string | undefined, sort?: 'asc' | 'desc') => void
}

export const OrderListContext = createContext<OrderListContextValue | null>(
  null,
)
